var map = {
	"./Badges.abi.js": 265,
	"./BuffiDai.abi.js": 266,
	"./Burner.abi.js": 267,
	"./BurnerVendor.abi.js": 268,
	"./DenDai.abi.js": 269,
	"./ENS.abi.js": 185,
	"./ENSResolver.abi.js": 186,
	"./ERC20Vendable.abi.js": 270,
	"./Emitter.abi.js": 187,
	"./Exchange.abi.js": 184,
	"./Links.abi.js": 271,
	"./StableCoin.abi.js": 188,
	"./VendingMachine.abi.js": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;